var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransparentArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 131,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M91.375.32v18.118h12.96L85 37.772 97.548 50.32l19.334-19.337v11.768H135V.32z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.845 12.32v13.77h9.849L33 40.783l9.536 9.537L57.23 35.624v8.943H71V12.32z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M62.953 65.32v11.233h8.034L59 88.54l7.78 7.78 11.987-11.989v7.296H90V65.32z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.04 98.32v5.798h4.147L104 110.305l4.015 4.015 6.187-6.188v3.766H120V98.32zM18.04 72.32v5.798h4.147L16 84.305l4.015 4.015 6.187-6.188v3.766H32V72.32zM2.04 27.32v5.798h4.147L0 39.305l4.015 4.015 6.187-6.188v3.766H16V27.32z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M107.188 59.32v9.059h6.479L104 78.046l6.274 6.274 9.667-9.668v5.883H129V59.32z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.423 111.32v6.885h4.924L68 125.552l4.768 4.768 7.347-7.348v4.472H87V111.32z"
  }))));
}
export default SvgTransparentArrows;